module.exports = require("react-responsive");